import fromMobile from "../utilities/isMobile";

/* Application State */
export const APPLICATION_REDUCER_TYPES = {
  SET_CURRENT_STEP: "SET CURRENT STEP",
  SET_JWT: "SET JWT",
  SET_ONBOARDING_STEPS: "SET ONBOARDING STEPS",
};

/* Onboarding Steps */
// Mapping of backend steps for what we need for FE
export const ONBOARDING_STEPS = {
  BasicInfo: "BASIC_INFO",
  Phone: "VERIFY_PHONE",
  Address: "ADDRESS",
  Identity: "VERIFY_IDENTITY",
  Accounts: "LINK_BANK",
  Confirm: "CONFIRM",
  Decision: "CONFIRM",
};

export const ONBOARDING_VERSION_1_0 = "1.0";
export const ONBOARDING_VERSION_2_0 = "2.0";

export const IS_MOBILE = fromMobile();